<template>
  <div
    class="update-content-info"
    :style="{
      backgroundImage: `url(${bgImg})`,
      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat',
    }"
  >
    <div class="close-btn" @click="close">
      <iconpark-icon name="close" size="16"></iconpark-icon>
    </div>
    <div class="text-font-1 text-[24px] flex-y-center">
      {{ $t('xin-gong-neng-jie-shao') }}
      <Resource
        :src="getFeUrl('/rendora/update-video.png')"
        :transformResource="transformImage"
        class="w-[27px] h-[24px] ml-[12px]"
      />
    </div>
    <div class="mt-[16px] flex gap-[12px] w-full">
      <a-tabs
        v-model:activeKey="activeKey"
        :style="{ width: '100%' }"
        class="update-nav"
        @change="chooseTab"
      >
        <a-tab-pane
          v-for="(item, index) in data"
          :key="index"
          :tab="item.title"
        >
        </a-tab-pane>
      </a-tabs>
    </div>
    <a-carousel
      ref="carouselRef"
      class="carousel"
      :autoplay="true"
      :after-change="onChange"
      :dots="true"
      :autoplaySpeed="5000"
    >
      <div
        v-for="item in data"
        :key="item.introduce_picture_url"
        class="w-full h-[368px] !flex-y-center justify-center bg-back-bg rounded-[16px]"
      >
        <img
          loading="lazy"
          class="max-w-full max-h-full"
          :src="item.introduce_picture_url"
        />
      </div>
    </a-carousel>
    <div
      v-if="data?.[activeKey]?.describe_content?.length"
      class="desc mt-[22px] h-[80px] overflow-auto"
    >
      <div
        v-for="(detail, index) in data?.[activeKey].describe_content"
        :key="index"
        class="text-font-1 text-14 mt-[5px] flex gap-[5px] break-all"
      >
        <Resource
          :src="getFeUrl('/rendora/update-circle.png')"
          :transformResource="transformImage"
          class="w-[15px] h-[15px] mt-[2px]"
        />
        {{ detail }}
      </div>
    </div>
    <div class="text-right mt-[20px]">
      <a v-if="link" class="mr-[34px]" :href="link" @click="goLink">{{
        $t('cha-kan-wan-zheng-ri-zhi')
      }}</a>
      <a-button type="primary" @click="close">
        {{ $t('wo-zhi-dao-le') }}
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { type ProjectLogItem } from '~/api/interface/auth'
import { UPDATE_PROJECT_SHOW } from '~/constants/config'
// import { MARKDOWN_NAME } from '~/constants/index'
// import { PageKey } from '~/constants/page'

const props = defineProps<{
  cancel: () => void
  data: ProjectLogItem[]
  link: string
}>()
const { $t } = useNuxtApp()
const activeKey = ref(0)
const carouselRef = ref()
const currentTheme = useTheme()

const bgImg = computed(() =>
  transformImage(
    getFeUrl(
      currentTheme.value === 'dark'
        ? '/rendora/update-bg2.png'
        : '/youyan-platform/png/update-bg-cn2.png'
    )
  )
)

const onChange = (index: number) => {
  activeKey.value = index
}

const chooseTab = (index: number) => {
  activeKey.value = index
  carouselRef.value?.goTo(index)
}

const close = () => {
  props.cancel()
  if (!localGetItem(UPDATE_PROJECT_SHOW)) {
    emitter.emit(EVENT.UPDATE_PROJECT_TIP)
  }
}

const goLink = () => {
  props.cancel()
}
</script>

<style lang="scss">
.xmov-update-info-modal {
  .ant-modal-content {
    background: none;
    border-radius: 12px !important;
  }
}
</style>
<style lang="scss" scoped>
.update-content-info {
  @apply relative rounded-[16px];
  padding: 30px 32px;
  .close-btn {
    @apply w-[24px] h-[24px] rounded-full absolute right-[12px] top-[12px] flex-y-center justify-center bg-back-1 cursor-pointer;
  }

  .carousel {
    // @apply mt-[16px];
    box-shadow: 0px 3px 25px 0px rgba(81, 80, 96, 0.2);
    border-radius: 16px;
  }
  :deep(.ant-carousel) {
    .slick-dots-bottom {
      bottom: -11px;
    }
    .slick-dots li {
      width: 10px;
    }
    .slick-dots li button {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #c9c5d2;
    }
    .slick-dots li.slick-active {
      width: 17px;
    }
    .slick-dots li.slick-active button {
      width: 100%;
      border-radius: 4px;
      background: var(--primary-color);
    }
  }

  :deep(.ant-tabs-ink-bar) {
    display: none;
  }
  :deep(.ant-tabs-top .ant-tabs-nav::before) {
    display: none;
  }
  :deep(.ant-tabs) {
    .ant-tabs-top .ant-tabs-nav::before,
    .ant-tabs-ink-bar {
      display: none;
    }
    .ant-tabs-tab {
      background: var(--update-modal-btn);
      border-radius: 8px;
      margin: 0 5px;
      color: var(--text-2);
      padding: 5px 15px;
    }

    .ant-tabs-tab-active {
      background: var(--primary-color);
      .ant-tabs-tab-btn {
        color: #fff;
      }
    }
  }
}
</style>
